import { STATUS } from "components/campaign/types";

export const getFinancialStr = (
  number: any,
  estimated?: any,
  hideTilde?: any
) => {
  var str = "";

  if (number !== null && number !== undefined && number !== "-") {
    if ((number + "").includes(" - ")) {
      let split = (number + "").split(" - ");
      str +=
        getFinancialStr(split[0], false, true) +
        " - " +
        getFinancialStr(split[1], false, true);
    } else if (number >= 1000000 || number <= -1000000) {
      str += "£";
      var millions: any = (number / 1000000).toFixed(2);
      if (number % 1000000 === 0) {
        millions = number / 1000000;
      } else if (number % 100000 === 0 || estimated) {
        millions = (number / 1000000).toFixed(1);
      }
      str += millions + "M";
    } else if (number >= 1000 || number <= -1000) {
      str += "£";
      var thousands: any = number / 1000;
      if (thousands < 10 && number % 1000 !== 0) {
        thousands = thousands.toFixed(1);
      } else {
        thousands = Math.floor(thousands);
      }
      str += thousands + "K";
    } else {
      str += "£";
      str += number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    if (estimated && !hideTilde) {
      str = "~" + str;
    }

    return str;
  } else {
    return "-";
  }
};

export const getFinancialStrInThousand = (number: any) => {
  if (number !== null && number !== undefined && number !== "-") {
    if ((number + "").includes(" - ")) {
      let split = (number + "").split(" - ");
      return getFinancialStr(split[0]) + " - " + getFinancialStr(split[1]);
    } else if (number >= 1000 || number <= -1000) {
      let thousands = number / 1000;
      if (thousands < 10 && number % 1000 !== 0) {
        return thousands.toFixed(1);
      } else {
        return Math.floor(thousands).toString();
      }
    } else {
      return number.toString();
    }
  } else {
    return "-";
  }
};

export const getFinancialStrInMillions = (number: any): string => {
  if (number !== null && number !== undefined && number !== "-") {
    const numStr = number + "";

    if (numStr.includes(" - ")) {
      const split = numStr.split(" - ");
      return (
        getFinancialStrInMillions(split[0]) +
        " - " +
        getFinancialStrInMillions(split[1])
      );
    }

    const numericValue = Number(number);

    if (!isNaN(numericValue)) {
      const millions = numericValue / 1_000_000;

      if (Math.abs(millions) < 10 && !Number.isInteger(millions)) {
        return millions.toFixed(2);
      } else {
        return Number.isInteger(millions)
          ? millions.toFixed(0)
          : millions.toFixed(2);
      }
    }

    return number.toString();
  } else {
    return "-";
  }
};

export const formatPercentage = (percentage: any) => {
  var newPercentage: any = +percentage;
  if (Math.abs(newPercentage) >= 1) {
    newPercentage = newPercentage.toFixed(1);
  } else {
    newPercentage = newPercentage.toFixed(2);
  }
  return newPercentage;
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const generateCampaignName = (existingNames: string[]) => {
  const baseName = `Campaign - ${new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })}`;
  let newName = baseName;
  let counter = 2;

  while (existingNames.includes(newName)) {
    newName = `${baseName} (${counter})`;
    counter++;
  }

  return newName;
};

export const formatPhoneNumber = (value: string) => {
  let cleaned = value.replace(/[^\d+]/g, "");

  if (!cleaned.startsWith("+")) {
    cleaned = `+44${cleaned}`; // Default to UK +44
  }

  const match = cleaned.match(/^(\+\d{1,3})(\d{4})(\d{3})(\d{3})$/);
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
  }

  return cleaned;
};

export const formatWebsite = (website: String) => {
  let value = website.trim();
  if (value && !/^www\./.test(value)) {
    value = "www." + value.replace(/^(https?:\/\/)?(www\.)?/, "");
  }
  return value;
};

export const formatDomain = (value: string): string => {
  let trimmedValue = value.trim().toLowerCase();

  // Remove protocol (http:// or https://)
  trimmedValue = trimmedValue.replace(/^(https?:\/\/)/, "");

  // Remove www. prefix
  trimmedValue = trimmedValue.replace(/^www\./, "");

  // Remove trailing slash and anything after it
  trimmedValue = trimmedValue.replace(/\/.*$/, "");

  return trimmedValue;
};

export const formatService = (name: string, quota: number | null): string => {
  if (quota === null) return name;

  switch (name) {
    case "Mailboxes":
      return `${quota} ${quota === 1 ? "Mailboxe" : "Mailboxes"}`;
    case "Domains":
      return `${quota} ${quota === 1 ? "Domain" : "Domains"}`;
    case "Team Members":
      return `${quota} ${quota === 1 ? "Team Member" : "Team Members"}`;
    default:
      return `${quota} ${name}`;
  }
};

export const calculateDaysRemaining = (endDate: string) => {
  const end = new Date(endDate);
  const now = new Date();
  const timeDiff = end.getTime() - now.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return daysDiff;
};

export const getCardWidthClass = (totalPlans: number) => {
  let widthClass = "w-full ";

  if (totalPlans === 1) {
    widthClass += "sm:w-4/5 md:w-2/3 lg:w-1/2";
  } else if (totalPlans === 2) {
    widthClass += "sm:w-[calc(50%-0.5rem)] md:w-[calc(50%-0.75rem)]";
  } else if (totalPlans === 3) {
    widthClass += "sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.67rem)]";
  } else if (totalPlans === 4) {
    widthClass += "sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)]";
  } else {
    widthClass +=
      "sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.67rem)] xl:w-[calc(25%-0.75rem)]";
  }

  return widthClass;
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const scrollToTopWithRadixScrollArea = () => {
  const viewport = document.querySelector(
    "[data-radix-scroll-area-viewport]"
  ) as HTMLElement | null;

  if (viewport) {
    viewport.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
export function getDateForLetterPreview(date = new Date()) {
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  const suffixes = ["th", "st", "nd", "rd"];
  const v = day % 100;
  const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];

  return `${day}${suffix} ${month} ${year}`;
}

export const formatNumber = (num: number | string) => {
  const parts = num.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

const currencySymbols: Record<string, string> = {
  usd: "$",
  gbp: "£",
  eur: "€",
  inr: "₹",
  jpy: "¥",
  aud: "A$",
  cad: "C$",
  cny: "¥",
  chf: "CHF",
  hkd: "HK$",
  nzd: "NZ$",
  krw: "₩",
  mxn: "Mex$",
  sek: "kr",
  zar: "R",
  brl: "R$",
  ron: "lei",
  rub: "₽",
  try: "₺",
  ind: "₹",
  aed: "AED",
};

export function getCurrencySymbol(code: string): string {
  const symbol = currencySymbols[code.toLowerCase()];
  return symbol || `£`;
}

export const getSICTitle = (code: any, sicJSON: any): any => {
  var foundSIC = false;

  for (const element of sicJSON) {
    if (element.sicCode === code) {
      foundSIC = true;
      return { found: true, title: element.title };
    } else {
      if (element.subValues.length > 0) {
        let res = getSICTitle(code, element.subValues);
        if (res.found) {
          foundSIC = true;
          return { found: true, title: res.title };
        }
      }
    }
  }

  if (!foundSIC) {
    return { found: false };
  }
};

export const getISICTitle = (code: any, isicJSON: any): any => {
  var foundISIC = false;

  for (const element of isicJSON) {
    if (element.sicCode === code) {
      foundISIC = true;
      return { found: true, title: element.title };
    } else {
      if (element.subValues.length > 0) {
        let res = getSICTitle(code, element.subValues);
        if (res.found) {
          foundISIC = true;
          return { found: true, title: res.title };
        }
      }
    }
  }

  if (!foundISIC) {
    return { found: false };
  }
};

export const generateSearchName = () => {
  const baseName = `Search - ${new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })} ${new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })}`;
  let newName = baseName;
  return newName;
};

export const isWithinLast30Days = (dateString: string) => {
  const createdAt = new Date(dateString);
  const now = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(now.getDate() - 30);
  return createdAt >= thirtyDaysAgo;
};

export const formatDateTime = (isoString: string): string => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${formattedDate} • ${formattedTime}`;
};

export const generateTimeAgo = (date: Date) => {
  const now = new Date();
  const diff = (now.getTime() - date.getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export function generateDateRange(days: number) {
  const result = [];
  const today = new Date();

  for (let i = 0; i <= days; i++) {
    const d = new Date();
    d.setDate(today.getDate() - i);
    result.unshift(new Date(d));
  }

  return result;
}

export const statusColor: Record<string, string> = {
  [STATUS.SENT]: "text-green-800",
  [STATUS.DRAFT]: "text-blue-800",
  [STATUS.WARMING]: "text-pink-700",
  [STATUS.RUNNING]: "text-green-800",
  [STATUS.QUEUED]: "text-yellow-800",
  [STATUS.PAUSED]: "text-gray-800",
  [STATUS.COMPLETED]: "text-purple-800",
  [STATUS.ERROR]: "text-red-800",
};

export const getInitials = (first: string, last: string) =>
  `${first[0]}${last[0]}`.toUpperCase();

export const getInitialsFromFullName = (fullName: string) => {
  if (!fullName) return "";

  const parts = fullName.trim().split(/\s+/);

  const first = parts[0];
  const last = parts.length > 1 ? parts[parts.length - 1] : "";

  return `${first[0] ?? ""}${last[0] ?? ""}`.toUpperCase();
};

export const getTimeLabel = (date: string) => {
  const messageDate = new Date(date);
  const now = new Date();

  if (messageDate.toDateString() === now.toDateString()) {
    return messageDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  if (messageDate.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  }

  return messageDate.toLocaleDateString();
};

export const getTimeLabelWithDay = (date: string): string => {
  const messageDate = new Date(date);
  const now = new Date();

  const timeFormatter: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const isSameDay = (d1: Date, d2: Date) =>
    d1.toDateString() === d2.toDateString();

  if (isSameDay(messageDate, now)) {
    return `Today, ${messageDate.toLocaleTimeString([], timeFormatter)}`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  if (isSameDay(messageDate, yesterday)) {
    return `Yesterday, ${messageDate.toLocaleTimeString([], timeFormatter)}`;
  }

  return messageDate.toLocaleString([], {
    year: "numeric",
    month: "short",
    day: "2-digit",
    ...timeFormatter,
  });
};

export const generateTempId = () =>
  `temp-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

export function getOrganizationBannerText(
  membersCount: number,
  maxAllowedMemberships: number,
  pendingInvitationsCount: number = 0
): string {
  const joinedText = `${membersCount} of ${maxAllowedMemberships} maximum team members joined`;
  const pendingText =
    pendingInvitationsCount > 0
      ? `, with ${pendingInvitationsCount} invitation${
          pendingInvitationsCount > 1 ? "s" : ""
        } pending`
      : "";

  return `Your team currently has ${joinedText}${pendingText}.`;
}
